import { Button } from "@shadcn/ui/button";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList, CommandSeparator } from "@shadcn/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@shadcn/ui/popover";
import { useI18nContext } from "@i18n/i18n-react";
import { ChevronDownIcon, MessageCirclePlus } from "lucide-react";
import { useState } from "react";

type CityPickerProps = {
	selectedCity: string | null;
	cities: Array<{ id: string; name: string }>;
	onSelectCity: (city: string) => void;
	onOpenChange?: (open: boolean) => void;
};

const SUGGEST_LOCATION_URL = "https://bacehub.de/#suggest-hub";

export const CityPicker = (props: CityPickerProps) => {
	const { selectedCity, cities, onSelectCity, onOpenChange } = props;
	const [isOpen, setIsOpen] = useState(false);
	const i18n = useI18nContext().LL["new-ui"];

	const handleSelect = (city: string) => {
		onSelectCity(city);
		setIsOpen(false);
		onOpenChange?.(false);
	};

	const handleOpenChange = (open: boolean) => {
		setIsOpen(open);
		onOpenChange?.(open);
	};

	return (
		<Popover open={isOpen} onOpenChange={handleOpenChange}>
			<PopoverTrigger asChild>
				<Button
					type="button"
					variant="outline"
					className="h-10 w-[168px] justify-between bg-background/95 px-4 text-sm leading-5 font-breit shadow-xl backdrop-blur"
					data-vaul-no-drag=""
				>
					{selectedCity ?? i18n.SELECT_CITY()}
					<ChevronDownIcon className="size-4 opacity-50" />
				</Button>
			</PopoverTrigger>
			<PopoverContent
				align="start"
				sideOffset={10}
				className="w-[calc(100vw-48px)] overflow-hidden rounded-md p-0 shadow-md"
				data-vaul-no-drag=""
				onOpenAutoFocus={(event) => {
					event.preventDefault();
				}}
			>
				<Command shouldFilter={true}>
					<CommandInput className="font-breit text-sm leading-5 font-normal" placeholder={i18n.SEARCH()} />
					<CommandList className="max-h-[224px]">
						<CommandEmpty className="font-breit text-sm leading-5 font-normal">{i18n.NO_CITY_FOUND()}</CommandEmpty>
						{cities.map((city) => (
							<CommandItem className="font-breit text-sm leading-5 font-normal" key={city.name} value={city.name} onSelect={() => handleSelect(city.name)}>
								{city.name}
							</CommandItem>
						))}
						<CommandSeparator />
					</CommandList>
				</Command>

				<div className="p-1">
					<Button type="button" variant="ghost" className="h-9 w-full justify-start px-2 font-breit text-sm leading-5 font-normal" asChild>
						<a href={SUGGEST_LOCATION_URL} target="_blank" rel="noopener noreferrer">
							<MessageCirclePlus className="size-4" />
							{i18n.SUGGEST_NEW_LOCATION()}
						</a>
					</Button>
				</div>
			</PopoverContent>
		</Popover>
	);
};
